import { NgModule } from '@angular/core';

// #region all modules

import { G2BarModule } from '@lxlib/chart/bar';
import { G2CardModule } from '@lxlib/chart/card';
import { G2CustomModule } from '@lxlib/chart/custom';
import { G2GaugeModule } from '@lxlib/chart/gauge';
import { G2MiniAreaModule } from '@lxlib/chart/mini-area';
import { G2MiniBarModule } from '@lxlib/chart/mini-bar';
import { G2MiniProgressModule } from '@lxlib/chart/mini-progress';
import { NumberInfoModule } from '@lxlib/chart/number-info';
import { G2PieModule } from '@lxlib/chart/pie';
import { G2RadarModule } from '@lxlib/chart/radar';
import { G2SingleBarModule } from '@lxlib/chart/single-bar';
import { G2TagCloudModule } from '@lxlib/chart/tag-cloud';
import { G2TimelineModule } from '@lxlib/chart/timeline';
import { TrendModule } from '@lxlib/chart/trend';
import { G2WaterWaveModule } from '@lxlib/chart/water-wave';

const MODULES = [
  G2BarModule,
  G2CardModule,
  G2CustomModule,
  G2GaugeModule,
  G2MiniAreaModule,
  G2MiniBarModule,
  G2MiniProgressModule,
  G2PieModule,
  G2RadarModule,
  G2TagCloudModule,
  G2TimelineModule,
  G2WaterWaveModule,
  G2SingleBarModule,
  NumberInfoModule,
  TrendModule,
];

// #endregion

@NgModule({ exports: MODULES })
export class LxlibChartModule {}
